import spacing from 'material-ui/styles/spacing';

export default {
  fontFamily: 'microsign, Quicksand-Bold, Quicksand',
  spacing: spacing,
  palette: {
    primary1Color: 'rgba(3,30,65)',
    primary2Color: 'rgba(3,30,65)',
    primary3Color: 'rgba(3,30,65, 0.90)',
    accent1Color: 'rgb(39, 123, 124)',
    accent2Color: 'rgb(222,222,222)',
    accent3Color: 'rgb(170,170,170)',
    textColor: 'rgb(34,34,34)',
    alternateTextColor: 'rgb(255,255,255)',
    canvasColor: 'rgb(255,255,255)',
    borderColor: 'rgb(222,222,222)',
    disabledColor: 'rgba(74,74,74,.3)',
    pickerHeaderColor: 'rgb(3,30,65)',
    clockCircleColor: 'rgb(34,34,34,.3)',
    shadowColor: 'rgb(34,34,34)',
  },
  dialog: {
    bodyColor: 'rgb(34,34,34)'
  }
};



// WEBPACK FOOTER //
// ./src/themes/portalTheme.js